module.exports = __webpack_public_path__ + "img/sunny.f8f8a1dd.png";